
import React, { useEffect, useState, useCallback } from "react";
import { TableFooter, Tooltip } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import { useDispatch, useSelector } from "react-redux";
import { headerSearch, unoTheme } from '../../../../../assets/styles/unoTheme';
import DefaultScrollWithHeaderContent from "../../../../utils/DefaultScrollWithHeaderContent";
import MyTable from '../../../../utils/MyTable';
import MyTextField from "../../../../utils/MyTextField";
import { applyMaskAmount, getTitleCod, greenOrRed } from "../../../../utils/utils";
import { useMemo } from "react";
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    dirName: {
        color: 'black',
        cursor: 'pointer',
        '&:hover': {
            color: 'blue'
        }
    },
    file: {
        cursor: 'pointer',
        '&:hover': {
            color: 'blue',
            '& svg': {
                color: 'blue'
            }
        }

    },
    noPaddingCell: {
        padding: '0px !important',
        height: '1px',
    },
    tableFixed: {
        tableLayout: 'fixed',
    },
    borderOnOpen: {
        '& > *': {
            borderBottom: 'unset',
        },
    },


    ellipsis: {
        whiteSpace: "nowrap", /* Impede a quebra de linha */
        overflow: "hidden", /* Garante que o texto extra seja ocultado */
        textOverflow: "ellipsis",
    },

    redInput: {
        '& input': {
            color: unoTheme.redMoney,
        }
    },

    greenInput: {
        '& input': {
            color: unoTheme.greenMoney,
        }
    },

    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .totalLinePL': {
            '& .MuiTableCell-root': {
                borderBottom: 'unset',
                color: 'white',
                background: unoTheme.mainColor,
            },
        },

        '& .disponibilityLine': {
            '& .MuiTableCell-footer': {
                color: 'black',
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            //color: unoTheme.greenMoney,
            fontSize: '14px',
        }
    },
});

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.black,
        color: 'white',
        //boxShadow: theme.shadows[1],
        fontSize: 11,
    },
    arrow: {
        color: theme.palette.common.black,
    },
}))(Tooltip);

export default function AlocationAssetsTab(props) {

    const { assetsFormatted,
        totalBalanceNow,
        disponibility,
        month,
        year,
        isLoading,
        valuesByIndex,
        newTotalBalance,
        newParticipations,
        handleChangeValuesByIndex, noAssets, handleRemoveAddedFund } = props;

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)

    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [resolutionName, setResolutionName] = useState(null);

    const innerLoad = useMemo(() => {

        if (noAssets) {
            return {
                emptyMessage: "Nenhuma carteira lançada",
                size: "small"
            }
        } else {
            if (isLoading) {

                return {
                    emptyMessage: "",
                    loadMessage: "Carregando ativos...",
                    size: "small"
                }
            } else {
                return null
            }
        }
    }, [isLoading, assetsFormatted, noAssets])

    useEffect(() => {

    }, [assetsFormatted])

    return (
        <div className={classes.root}>
            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>
                <MyTable
                    stickyHeader
                    size="small">
                    <colgroup>
                        <col width="20%" />
                        <col width="15%" />
                        <col width="12.5%" />
                        <col width="12.5%" />
                        <col width="15%" />
                        <col width="7.5%" />
                        <col width="7.5%" />
                        <col width="10%" />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Ativo</TableCell>
                            <TableCell align="right">Saldo</TableCell>
                            <TableCell align="right">Resgates</TableCell>
                            <TableCell align="right">Aplicações</TableCell>
                            <TableCell align="right"><span style={{ gap: "6px", display: "flex", alignItems: 'center', justifyContent: "flex-end" }}><ShowChartIcon /> <div>Saldo</div></span></TableCell>
                            <TableCell align="right">
                                <LightTooltip title={"Participação na carteira"} placement="top" arrow>
                                    <span>Part.</span>
                                </LightTooltip>
                            </TableCell>
                            <TableCell align="right"></TableCell>
                            <TableCell align="center">
                                {resolutionName ? resolutionName : '-'}
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {assetsFormatted.map((row, index) => {

                            const isTitle = row.title_id != null;
                            return (
                                <TableRow key={'asset-' + index}>
                                    <TableCell align="left" style={row.addedFund ? { color: "blue" } : null}>
                                        <div style={{ display: "flex", alignItems: 'center', gap: "8px" }}>
                                            {row.addedFund && <DeleteIcon style={{ cursor: "pointer" }} onClick={() => handleRemoveAddedFund(index)} />}
                                            <div className={classes.ellipsis}>{!isTitle ? row.fund_name : getTitleCod(row)}
                                            </div>
                                        </div>
                                    </TableCell>

                                    {/* Saldo */}
                                    <TableCell align="right" className={classes.green}>

                                        <span style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "end",
                                            gap: "4px"
                                        }}>


                                            {
                                                row.balance_now != undefined ?
                                                    applyMaskAmount(row.balance_now, true)
                                                    : 'Não informado'
                                            }
                                        </span>
                                    </TableCell>

                                    {/* Resgates */}
                                    <TableCell align="right">
                                        <MyTextField
                                            className={classes.redInput}
                                            verysmall
                                            mask={["currency"]}
                                            align="right"
                                            id={"rescues-" + index}
                                            labelclassname={classes.noMarginTop}
                                            value={valuesByIndex?.[index]?.rescues}
                                            onChange={(value) => handleChangeValuesByIndex(index, value, "rescues")}
                                            fullWidth />
                                    </TableCell>

                                    {/* Aplicações */}
                                    <TableCell align="right">
                                        <MyTextField
                                            className={classes.greenInput}
                                            id={"applictions-" + index}
                                            verysmall
                                            mask={["currency"]}
                                            align="right"
                                            labelclassname={classes.noMarginTop}
                                            value={valuesByIndex?.[index]?.applications}
                                            onChange={(value) => handleChangeValuesByIndex(index, value, "applications")}
                                            fullWidth />
                                    </TableCell>

                                    <TableCell align="right" style={{ color: greenOrRed(valuesByIndex?.[index]?.newBalanceNow) }}>
                                        {valuesByIndex?.[index]?.newBalanceNow != null ? applyMaskAmount(valuesByIndex?.[index]?.newBalanceNow, true) : "-"}
                                    </TableCell>

                                    {/* Participação */}
                                    <TableCell align="right">
                                        {row.participation}%
                                    </TableCell>
                                    <TableCell align="right" style={{ color: "blue" }}>
                                        {newParticipations?.[index] != null ? applyMaskAmount(newParticipations[index]) + "%" : "-"}
                                    </TableCell>

                                    {/* Enquadramento */}
                                    <TableCell align="center">
                                        {row.device_abbreviation ? row.device_abbreviation : '-'}
                                    </TableCell>



                                </TableRow>
                            )
                        })}
                    </TableBody>
                    {
                        assetsFormatted && assetsFormatted.length > 0 ?
                            <TableFooter className={classes.myTableFooter}>
                                <TableRow className='totalLineInvestiments' key={'footer-t-assets-collect-investiments'}>
                                    <TableCell align="left">TOTAL INVESTIMENTOS</TableCell>
                                    <TableCell align="right"><span className={'spanTotal'}>{totalBalanceNow ? applyMaskAmount(totalBalanceNow, true) : "-"}</span></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="right"><span className={'spanTotal'}>{newTotalBalance ? applyMaskAmount(newTotalBalance, true) : "-"}</span></TableCell>
                                    <TableCell align="right"><span className={'spanTotal'}>100%</span></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                                <TableRow className='disponibilityLine' key={'footer-t-assets-collect-disponibility'}>
                                    <TableCell align="left">DISPONIBILIDADE</TableCell>
                                    <TableCell align="right"><span className={'spanTotal'}>{disponibility != null ? applyMaskAmount(disponibility, true) : "-"}</span></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="right"><span className={'spanTotal'}>{disponibility != null ? applyMaskAmount(disponibility, true) : "-"}</span></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                                <TableRow className='totalLinePL' key={'footer-t-assets-collect-total'}>
                                    <TableCell align="left">TOTAL PATRIMÔNIO</TableCell>
                                    <TableCell align="right"><span className={'spanTotal'}>{totalBalanceNow != null && disponibility != null ?
                                        applyMaskAmount(totalBalanceNow + disponibility, true) : '-'}</span></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="right">
                                        <span className={'spanTotal'}>{newTotalBalance != null && disponibility != null ?
                                            applyMaskAmount(newTotalBalance + disponibility, true) : '-'}</span>
                                    </TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableFooter> : null
                    }
                </MyTable>
            </DefaultScrollWithHeaderContent>
        </div>
    );
}



